import React, {useEffect} from 'react';
import {Grid,Typography, Card ,IconButton, Tooltip,Icon, Box, CardContent, Container} from '@mui/material';
import { servicesStyles } from '../../styles/landing';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person'
import ApartmentIcon from '@mui/icons-material/Apartment';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import GroupIcon from '@mui/icons-material/Group';
import { fetchClients } from '../../actions/client';
import {getReport} from '../../actions/report';
import { NavLink } from 'react-router-dom';
import { fetchArbors, getProfile } from '../../actions/arboristLogin';
import { fetchAllProperties } from '../../actions/property';
import { useDispatch, useSelector } from 'react-redux';
import {Charts, PieCharts} from '../common/charts';
import { validateUserType } from '../../ValidateUserType';

 const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width:"80%",
  height:"100%",
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  paddingBottom:'20px !important',
  // height:"150px",
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main },
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '24px',
  fontWeight: '500',
  color: theme.palette.primary.main,
}));

 

const Arbor = () => {
    const dispatch = useDispatch()
    const classes = servicesStyles()
    const {clients} = useSelector(({client})=>client)
    const {allReports} = useSelector(({report})=> report)
    const {properties} = useSelector(({property})=>property)
    const {arbors}=useSelector(({arbor})=>arbor)
    const cardList = validateUserType()?
    [
      { name: 'Arbors', amount:arbors?.length ? arbors?.length :0, path:"/arborManager", icon: <AutoStoriesIcon sx={{fontSize:45}} /> }
      // { name: 'Orders to deliver', amount: '305 Orders', icon: 'shopping_cart' },
    ]
    :[
      { name: 'Reports', amount:allReports?.length ? allReports?.length :0, path:"/reports", icon: <AutoStoriesIcon sx={{fontSize:45}} /> },
      { name: 'Clients', amount: clients?.length ? clients?.length : 0, path:"/clientManager", icon: <GroupIcon sx={{fontSize:45}} /> },
      { name: 'Properties', amount:properties?.length ? properties?.length:0, path:"/properties", icon: <ApartmentIcon sx={{fontSize:45}}/> },
      // { name: 'Orders to deliver', amount: '305 Orders', icon: 'shopping_cart' },
    ];
  
    useEffect(()=>{
     if(validateUserType()){
      // dispatch(getProfile())
         dispatch(fetchArbors())
      // dispatch(fetchClients())
      // dispatch(fetchAllProperties())
     }
     else{
      dispatch(getProfile())
      dispatch(fetchClients())
      dispatch(fetchAllProperties())
      dispatch(getReport())
     }
  },[])
  return (
    <>   
    <Container sx={{ py: 2 , pl:2}}>    
    <Grid container spacing={6} sx={{ mb: '34px', mt:1 }}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={3} key={index} >
        <NavLink to ={item.path} style={{textDecoration: 'none'}}>
          <Card sx={{borderRadius:4, background:"linear-gradient(to bottom, #9156ab,#a778bc, #bd9acd )"}}>
            <CardContent >
            <Box ml="12px">
              <Grid container justify="center" style={{display:"flex", justifyContent:"center"}}>
              <Grid item>
              <Icon className="icon" sx={{color:"#f2eef7", height:50, width:50,}}>{item.icon}</Icon>   
              </Grid> 
              </Grid>  
              <Grid container justify="center" style={{display:"flex", justifyContent:"center"}}>
                <Grid item>      
                <Typography variant="h5" sx={{color:"#f2eef7"}}>{item.name}</Typography>
                </Grid>   
                </Grid>
                <Grid container justify="center" style={{display:"flex", justifyContent:"center"}}>
                <Grid item>    
                <Heading sx={{color:"#f2eef7"}}>{item.amount}</Heading> </Grid>   
                </Grid>
              </Box>
            </CardContent>
            <Tooltip title="View Details" placement="top">
              <IconButton>
                {/* <Icon>arrow_right_alt</Icon> */}
              </IconButton>
            </Tooltip>
          </Card></NavLink>  
        </Grid>
      ))}
               
    </Grid>
    <Grid container justify="center" spacing={4}>
      <Grid item xs={12} lg={8}>
    <Card sx={{borderRadius:4, p:4}}>
            <Charts/>
          </Card>
          </Grid>
          <Grid item sx={12} lg={4}>
          <Card sx={{borderRadius:4, p:4}}>
            <PieCharts/>
          </Card>
          </Grid>
          </Grid>
    </Container>
    </>
  )
}

export default Arbor